import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManageCustomfields from 'src/components/Elements/ManageCustomfields';

const CustomFieldManagementModal = () => (
  <ModalBase
    name={MODALS.manageCustomFields}
    size={MODALS_SIZE.small}
    form={FORM.get_customfields}>
    <ManageCustomfields />
  </ModalBase>
);

export default CustomFieldManagementModal;
